import {
  FilterOptionKeys,
  GroupByMode,
  SortingMode,
  TaskGroupBy,
} from '@griply/types';

export const inboxGroupOptions = [
  GroupByMode.None,
  GroupByMode.Priority,
  GroupByMode.Tag,
] as const satisfies readonly TaskGroupBy[];

export const inboxSortOptions = [
  SortingMode.Custom,
  SortingMode.Priority,
  SortingMode.CreatedAt,
  SortingMode.Name,
] as const satisfies readonly SortingMode[];

export const inboxFilters = [
  FilterOptionKeys.Priority,
  FilterOptionKeys.Tag,
  FilterOptionKeys.Duration,
] as const satisfies readonly FilterOptionKeys[];
